<template>
  <section v-if="finishedLoading">
    <h4 class="is-size-4">Loading student data...</h4>

    <b-skeleton width="20%" animated></b-skeleton>

    <b-skeleton width="40%" animated></b-skeleton>

    <b-skeleton width="80%" animated></b-skeleton>

    <b-skeleton animated></b-skeleton>
  </section>
</template>

<script>
export default {
  props: ['finishedLoading'],
  computed: {
    shouldFetchMoreRecords() {
      return (
        this.$store.state.application.offset <
        this.$store.state.application.totalNoApplcations
      );
    },
  },
};
</script>
